<div class="card-deck">
  <div class="card">
    <img class="card-img-top" src="assets/images/porton_promo_chica.png" alt="Card image cap">
    <div class="card-body">
      <img class="card-img-left" src="assets/images/porton_logo_chica.png" alt="Card image cap">
      <h5 class="card-title">El Portón</h5>
      <p class="card-text">Obtén 15% en el total de tu compra.</p>
    </div>
    <div class="card-img-right">
      <small class="text-muted"><p class="text-right">Conoce más ></p></small>
    </div>
  </div>
  <div class="card">
    <img class="card-img-top" src="assets/images/porton_promo_chica.png" alt="Card image cap">
    <div class="card-body">
      <img class="card-img-left" src="assets/images/porton_logo_chica.png" alt="Card image cap">
      <h5 class="card-title">El Portón</h5>
      <p class="card-text">Obtén 15% en el total de tu compra.</p>
    </div>
    <div class="card-img-right">
      <small class="text-muted"><p class="text-right">Conoce más ></p></small>
    </div>
  </div>
  <div class="card">
    <img class="card-img-top" src="assets/images/porton_promo_chica.png" alt="Card image cap">
    <div class="card-body">
      <img class="card-img-left" src="assets/images/porton_logo_chica.png" alt="Card image cap">
      <h5 class="card-title">El Portón</h5>
      <p class="card-text">Obtén 15% en el total de tu compra.</p>
    </div>
    <div class="card-img-right">
      <small class="text-muted"><p class="text-right">Conoce más ></p></small>
    </div>
  </div>
  <div class="card">
    <img class="card-img-top" src="assets/images/porton_promo_chica.png" alt="Card image cap">
    <div class="card-body">
      <img class="card-img-left" src="assets/images/porton_logo_chica.png" alt="Card image cap">
      <h5 class="card-title">El Portón</h5>
      <p class="card-text">Obtén 15% en el total de tu compra.</p>
    </div>
    <div class="card-img-right">
      <small class="text-muted"><p class="text-right">Conoce más ></p></small>
    </div>
  </div>
</div>
